module.exports = __webpack_public_path__ + "img/Group.a900511b.svg";